import {TTableColumnFilterExpressionDto} from 'components/@common/widgets/custom-table/table-column-filter/table-column-filter-types';
import {IReportConfigurationReportGroupDto} from 'store/slices/report-configuration-slice/report-configuration-dto';
import {
    TTableReportColumnSortForRequest,
    ITableReportDrilldownParameter,
    TTableReportQueryParameters,
    TTableReportRequestParameters,
} from 'store/slices/table-report-slice/table-report-slice-types';

export enum EDesignTemplates {
    DECLARATION = 'DECLARATION',
    REGISTERS = 'REGISTERS',
    TABLE_REPORT_DESIGN_TEMPLATE_WITH_PARAMETER = 'TABLE_REPORT_DESIGN_TEMPLATE_WITH_PARAMETER',
    DOCS_FILTERS = 'DOCS_FILTERS',
    POSTING_CARD = 'POSTING_CARD',
    REGISTER_WITH_ROW_HEADERS = 'REGISTER_WITH_ROW_HEADERS',
    TABLE_REPORT_DESIGN_TEMPLATE_WITH_PARAMETER_AND_HEADER = 'TABLE_REPORT_DESIGN_TEMPLATE_WITH_PARAMETER_AND_HEADER',
}

export const DESIGN_TEMPLATES_WITH_PARAMETERS: string[] = [
    EDesignTemplates.TABLE_REPORT_DESIGN_TEMPLATE_WITH_PARAMETER,
    EDesignTemplates.TABLE_REPORT_DESIGN_TEMPLATE_WITH_PARAMETER_AND_HEADER,
];

export enum EReportViewMode {
    DETAILED = 'detailed',
    SUMMARY = 'summary',
}

export interface ITableReportPassedDrilldownParams {
    drillId?: string;
    drillParameters?: ITableReportDrilldownParameter[];
}

export interface ITableReportRequestTopicParams {
    TOPIC_REQUEST_ID?: string;
    TOPIC_REQUEST_PARAMS?: TTableReportRequestParameters;
}

export interface ITableReportCustomCrParams {
    CONTROL_RATIO_ID?: number;
    PARENT_DOC_ID_CR?: string | null;
    ANALYTICS?: string | null;
}

export type TTableReportRequestGeneralParams = Record<string, unknown>;

export interface ITableReportLocationDefaults {
    locationPage?: number;
    locationSize?: number;
    locationFilters?: TTableColumnFilterExpressionDto;
    locationSort?: TTableReportColumnSortForRequest[];
    locationParameters?: TTableReportQueryParameters;
    locationReportGroups?: {
        reportGroups: { [reportGroupName: string]: IReportConfigurationReportGroupDto } | undefined;
        groupAfterUserFilter: boolean | undefined;
    };
}

export interface ITableReportProps {
    entityName?: string;
    docId: string | null;
    templateCode: string;
}

export interface IReportRowLinks {
    reportRowId: string;
    links: {
        columnName: string;
        link: string | number | object | boolean;
    }[];
}
